exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choosepeople .el-checkbox-group>.el-checkbox+.el-checkbox{color:#333;margin:0}.choosepeople .el-checkbox__input>.el-checkbox__inner{width:20px;height:20px;border-radius:50%}.choosepeople .el-checkbox__input>.el-checkbox__inner:after{left:7px;top:4px}.choosepeople .el-checkbox>.el-checkbox__input.is-checked+.el-checkbox__label{color:#333}.choosepeople .el-checkbox>.el-checkbox__input{margin-top:-30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91ef3aea","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/packages/mselector/um-mselector.vue
// module id = 90
// module chunks = 0